
define('utility/string/string',['require','../method-loader'],function (require) {
    'use strict';
    // convenience loader that returns only the specified string methods needed by the module

    var MethodLoader = require('../method-loader');

    return new MethodLoader('utility/string/string.', {
        'format': 'utility/string/string.format',
        'pluralize': 'utility/string/string.pluralize',
        'addCommas': 'utility/string/string.add-commas',
    });
});